<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="16">
              <div style="background-color:#fff;border:1px solid #ccc;">
                <div style="padding:.5rem .5rem;box-sizing:border-box;overflow:hidden;">
                  <div style="float:left;font-size:1.2rem;font-weight:bold;">温湿度监控区</div>
                  <div style="float:left;padding-left:1rem;">
                      <el-select
                        v-model="projectId"
                        placeholder="请选择项目名称"
                        @change="projectChange"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="(item, index) in projectList"
                          :key="index"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                  </div>
                </div>
                <div class="grid-content" style="height:calc(100vh - 10.5rem);overflow-y:scroll;">
                  <div style="overflow:hidden;" v-if="deviceList.length>0">

                    <div v-for="(item,index) in deviceList" :key="index" style="width:25%;float:left;box-sizing:border-box;padding:.5rem .5rem;font-size:.3rem;">
                      <div style="border:1px solid #ccc;box-sizing:border-box;padding:.5rem .5rem;">
                        <div style="display:flex;">
                          <div style="flex:3">
                            <div style="width:100%;height:1rem;overflow: hidden;
text-overflow: ellipsis;
display: -webkit-box;
-webkit-line-clamp: 1;
-webkit-box-orient: vertical;">{{item.areaName}}</div>
                            <div style="width:100%;height:2rem;overflow : hidden;
text-overflow: ellipsis;
display: -webkit-box;
-webkit-line-clamp: 2;
-webkit-box-orient: vertical;">{{item.meterName}}</div>
                          </div>
                          <div style="flex:2">
                            <div>{{item.lastCollectTime[0]}}</div>
                            <div>{{item.lastCollectTime[1]}}</div>
                            <!-- <div>12:30:30</div> -->
                          </div>
                        </div>
                        <div style="padding-top:.5rem;">
                          <div style="box-sizing:border-box;padding-left:1rem;overflow:hidden;overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;">
                            <!-- <div style="overflow:hidden;display:inline-block;"> -->
                              <img src="/img/temp_normal.png" alt="" style="float:left;"/>
                            <!-- </div> -->
                            {{item.tempValue===''?('     温度     暂无数据'):("     温度    "+item.tempValue+item.tempUnit)}}
                          </div>
                          <div style="box-sizing:border-box;padding-left:1rem;overflow:hidden;overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;">
                            <!-- <div style="overflow:hidden;display:inline-block;"> -->
                              <img src="/img/humidity_normal.png" alt="" style="float:left;"/>
                            <!-- </div> -->
                            {{item.humidityValue===''?('     湿度     暂无数据'):("     湿度    "+item.humidityValue+item.humidityUnit)}}
                          </div>
                        </div>
                      </div> 
                    </div>

                  </div>

                  <div style="overflow:hidden;box-sizing:border-box;padding:.5rem .5rem;" v-else >
                    暂无消息
                  </div>

                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div style="background-color:#fff;border:1px solid #ccc;">
                <div style="padding:.5rem .5rem;box-sizing:border-box;overflow:hidden;font-size:1.2rem;font-weight:bold;text-align:center;">
                  异常告警信息
                </div>
                <div class="grid-content" style="height:calc(100vh - 10.5rem);overflow-y:scroll;">
                    <div v-if="messageList.length>0">
                      <div v-for="(item,index) in messageList" :key="index" style="box-sizing:border-box;padding:.5rem .5rem;">
                        {{(index+1)+'. '+item.warningTime+' '+item.meterName+' '+item.exceptionDesc}}
                      </div>
                    </div>
                    <div v-else style="box-sizing:border-box;padding:.5rem .5rem;">
                      暂无信息
                    </div>
                </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { getProjectList } from '@/api/crmedical/project/project';
import {getDataWarningList, getDataMonitorList} from"@/api/crmedical/humidity-monitor/index";
export default {
    data(){
        return{
          deviceList:[],
          messageList:[],
          projectId:'',
        }
    },
    destroyed(){
            clearInterval(this.intervalController);
    },
    
    beforeRouteLeave(to,from,next){
            clearInterval(this.intervalController);
            next();
    },
    activated(){
        let self = this;
        getProjectList().then((res) => {
          this.projectList = res.data;
          if (this.projectList.length > 0) {
            // this.$set(this.query, 'projectId', this.projectList[0].id);
            // this.$set(this.boardSearch, 'projectId', this.projectList[0].id);
            this.projectId = this.projectList[0].id;
            this.projectChange(this.projectId);
            this.intervalController = setInterval(() => {
              self.projectChange(self.projectId);
            },60000);
            window.onunload = ()=>{
              clearInterval(self.intervalController);
            }
          }
        });
    },
    mounted(){
        // getDataWarningList({projectId:'1111'}).then((res)=>{
        //   console.log(res.data);
        //   this.messageList = res.data;
        // });
        // getDataMonitorList({projectId:'1111'}).then((res)=>{
        //   console.log(res.data);
        //   this.deviceList = res.data;
        // });
        let self = this;
        getProjectList().then((res) => {
          this.projectList = res.data;
          if (this.projectList.length > 0) {
            // this.$set(this.query, 'projectId', this.projectList[0].id);
            // this.$set(this.boardSearch, 'projectId', this.projectList[0].id);
            this.projectId = this.projectList[0].id;
            this.projectChange(this.projectId);
            this.intervalController = setInterval(() => {
              self.projectChange(self.projectId);
            },60000);
            window.onunload = ()=>{
              clearInterval(self.intervalController);
            }
          }
        });
    },
    methods:{
      projectChange(val){
        // val = '';
        getDataWarningList({projectId:val}).then((res)=>{
          console.log(res.data);
          this.messageList = res.data;
        });
        getDataMonitorList({projectId:val}).then((res)=>{
          console.log(res.data);
          this.deviceList = res.data;
          this.deviceList.map((item)=>{
            if(item.tempValue+''==='null'){
              item.tempValue = '';
            }
            if(item.lastCollectTime){
              item.lastCollectTime = [item.lastCollectTime.split(' ')[0],item.lastCollectTime.split(' ')[1]];
            }
            if(item.humidityValue+''==='null'){
              item.humidityValue = '';
            }
          })
        });
      },
    },
}
</script>

<style lang="scss" scoped>
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
</style>